import React, { useMemo } from 'react';
import { mergeClasses, Tooltip } from '@fluentui/react-components';
import { useColorButtonStyles } from './style';

function hexToBase64Color(hexColor) {
  // Create a canvas element
  const canvas = document.createElement('canvas');
  canvas.width = 34;
  canvas.height = 34;

  // Get the 2D drawing context
  const ctx = canvas.getContext('2d');
  if (!ctx) {
    throw new Error('Canvas is not supported in this environment');
  }

  // Set the fill style to the provided hex color
  ctx.fillStyle = hexColor;

  // Fill the canvas with the color
  ctx.fillRect(0, 0, canvas.width, canvas.height);

  // Convert the canvas content to a Base64 data URL
  const base64Image = canvas.toDataURL('image/png');

  return base64Image;
}

export const ColorButton = (props) => {
  const {
    color,
    draw,
    ariaLabel,
  } = props;

  const colorButtonStyles = useColorButtonStyles(color);
  const src = useMemo(() => hexToBase64Color(color), [color]);

  const onKeyDown = (event) => {
    if (event.key === 'Enter') {
      draw(color, ariaLabel);
      event.preventDefault();
    }
  };

  return (
    <Tooltip
      withArrow
      appearance="inverted"
      relationship="label"
      content={ariaLabel || color}
    >

      <div
        className={mergeClasses('color-button', colorButtonStyles)}
        role="button"
        onClick={() => draw(color, ariaLabel)}
        onKeyDown={onKeyDown}
        tabIndex={0}
        aria-label={ariaLabel}
      >
        <img
          style={{ display: 'block' }}
          src={src}
          alt={ariaLabel}
        />
      </div>
    </Tooltip>
  );
};
